module.exports = __webpack_public_path__ + "img/event-view-010.7141e8a2.png";